export const BUILDER_EVENT_INTERACTION_BLOCKED = 'website-builder:interaction-blocked';

export function dispatchBuilderInteractionBlocked(): void {
  window.dispatchEvent(new CustomEvent(BUILDER_EVENT_INTERACTION_BLOCKED));
}

/**
 * Erreur du cut builder (checkout joué dans l'aperçu de l'éditeur) : `message` est un texte
 * UTILISATEUR déjà traduit, à afficher tel quel. À distinguer des erreurs API dont `message`
 * est générique et dont la clé (`errorKey`) passe par `resolveApiErrorLabel` — cf. les
 * `resolveError`/`catch` des tunnels, qui sans ce marqueur retombaient sur `error_generic`
 * et masquaient l'explication « aucune réservation n'a été créée ».
 */
export class BuilderCutError extends Error {
  public readonly builder_cut = true;
}

/** Garde par propriété (pas `instanceof` seul) : robuste aux doubles instances de module. */
export function isBuilderCutError(e: unknown): e is BuilderCutError {
  return e instanceof Error && (e as { builder_cut?: boolean }).builder_cut === true;
}
